import React from "react";

import { StyleSheet, Text, View } from "@react-pdf/renderer";

import { MealKind } from "@/gql/graphql";
import { humanize } from "@/utils/string";

import MealRatingIconPDF from "./MealRatingIconPDF";
import MealTypeIconPDF from "./MealTypeIconPDF";
import { RatingReport } from "../../utils/types";

interface MealRatingReportPDFItemProps {
  item: Record<MealKind, RatingReport[]>;
  width?: string | number;
}

const MealRatingReportPDFItem: React.FC<MealRatingReportPDFItemProps> = ({
  item,
  width,
}) => {
  const type = Object.keys(item)[0] as MealKind;
  const ratings = Object.values(item)[0];

  return (
    <View style={{ ...styles.container, width: width || "49%" }}>
      <Text style={styles.title}>{humanize(type).toUpperCase()}</Text>
      <View style={styles.h16} />
      <View style={styles.mealTypeAndRatingContainer}>
        <View
          style={{ ...styles.mealTypeContainer, flex: width ? 1 : undefined }}
        >
          <MealTypeIconPDF mealType={type} />
        </View>
        <View style={styles.w16} />
        <View style={styles.mealRatingContainer}>
          <View style={styles.ratings}>
            {ratings.map((i) => {
              const isLastItem = ratings.length - 1 === i;

              return (
                <View
                  key={i.rating}
                  style={{
                    ...styles.ratingContainer,
                    paddingRight: !isLastItem ? 8 : undefined,
                  }}
                >
                  <Text style={styles.totalRating}>{i.totalRating}</Text>
                  <View style={styles.w4} />
                  <MealRatingIconPDF rating={i.rating} />
                </View>
              );
            })}
          </View>
          <Text style={styles.clientReports}>Client Ratings</Text>
        </View>
      </View>
    </View>
  );
};

export default MealRatingReportPDFItem;

const styles = StyleSheet.create({
  container: {
    border: "2px dotted #EDF0F5",
    padding: 16,
  },
  title: {
    fontFamily: "Mulish",
    fontSize: 12,
    fontWeight: 700,
    color: "#363E45",
  },
  mealTypeAndRatingContainer: {
    display: "flex",
    flexDirection: "row",
  },
  mealTypeContainer: {
    backgroundColor: "#F5F7FA",
    borderRadius: 4,
    justifyContent: "center",
    padding: "16px 24px",
    alignItems: "center",
  },
  mealRatingContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "space-between",
  },
  ratingContainer: {
    display: "flex",
    flexDirection: "row",
  },
  ratings: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    rowGap: 16,
    flexWrap: "wrap",
    width: "135px", // Had to make specific width so the layout of ratings won't change
  },
  totalRating: {
    fontFamily: "Mulish",
    fontSize: 12,
    fontWeight: 700,
  },
  clientReports: {
    color: "#7D8797",
    fontFamily: "Mulish",
    fontSize: 10,
    fontWeight: 700,
  },
  h16: {
    height: 16,
  },
  w16: {
    width: 16,
  },
  w4: {
    width: 4,
  },
});
